"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDocumentThumb = useDocumentThumb;
var _auth = require("@ori/auth");
var _axios = require("@ori/axios");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _swr = _interopRequireDefault(require("swr"));
var _contexts = require("../../../contexts");
var _useTranslations_simplifiedRegistrationBrandPartner = require("../../../hooks/useTranslations_simplified-registration-BrandPartner");
var _interfaces = require("../../../interfaces");
var _TranslationKey_simplifiedRegistrationBrandPartner = require("../../TranslationKey_simplified-registration-BrandPartner");
const axiosClient = _axios.axios.create();
const getEncodedFile = blob => URL.createObjectURL(blob);
function useDocumentThumb(customerId, documentId, previewSize) {
  const {
    registrationId
  } = (0, _contexts.useConfiguration)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    globalApiUrl
  } = (0, _configurationManager.useServiceUrls)(['globalApi']);
  const {
    formattedToken
  } = (0, _auth.useToken)();
  const {
    formatMessage
  } = (0, _useTranslations_simplifiedRegistrationBrandPartner.useTranslations)();
  const {
    notificationData
  } = (0, _contexts.useNotificationData)();
  const {
    setNotificationData
  } = notificationData;
  const errorMeesage = formatMessage(_TranslationKey_simplifiedRegistrationBrandPartner.TranslationKey.cannotGetData);
  const thumbUrl = `${globalApiUrl}/customers/${customerId}/documents/${documentId}/image`;
  const shouldFetch = Boolean(customerId && documentId && documentId !== -1);
  const fetchKey = shouldFetch ? `thumb-${customerId}-${documentId}` : null;
  const fetcher = async ({
    url,
    tenant,
    registrationId,
    formattedToken,
    previewSize
  }) => {
    if (!fetchKey) {
      return undefined;
    }
    try {
      const headers = {
        'x-tenant-context': tenant,
        'x-registration-id': registrationId,
        Authorization: formattedToken
      };
      const response = await axiosClient.get(url, {
        headers,
        responseType: 'blob',
        params: previewSize
      });
      return getEncodedFile(response.data);
    } catch (error) {
      setNotificationData({
        isOpen: true,
        message: errorMeesage,
        type: _interfaces.MessageType.error,
        messageId: 'cannotGetData'
      });
      const axiosError = error;
      throw new Error(axiosError.message);
    }
  };
  const {
    data: documentURL
  } = (0, _swr.default)(fetchKey ? [fetchKey, {
    url: thumbUrl,
    tenant,
    registrationId,
    formattedToken,
    previewSize
  }] : null, () => fetcher({
    url: thumbUrl,
    tenant,
    registrationId,
    formattedToken,
    previewSize
  }));
  return documentURL;
}